import { useCurrentUser } from "hooks/auth";
import { useHasPerformanceManagementAccess } from "hooks/featureFlags";

interface SupplierPerformancePermissions {
	canCreate: boolean;
	canDelete: boolean;
	canExport: boolean;
	canView: boolean;
}

export const useSupplierPerformancePermissions = (): SupplierPerformancePermissions => {
	const hasAccess = useHasPerformanceManagementAccess();
	const { isCompanyAdmin, isExecutiveUser } = useCurrentUser() ?? {};

	const canView = hasAccess;
	const canCreate = hasAccess && (!!isCompanyAdmin || !!isExecutiveUser);
	const canDelete = !!isCompanyAdmin;
	const canExport = hasAccess;

	return {
		canView,
		canCreate,
		canDelete,
		canExport,
	};
};
